module.exports = new __parcel__URL__("map-marker-roof-selected.37aedd5c.svg").toString();